import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { GlobalService } from "../../services/global.service";

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LogsComponent implements OnInit {

  logs: any[] = [];
  filteredLogs: any[] = [];
  total = 0;
  currentPage = 1;
  totalPages = 1;
  categories: string[] = [];
  categorie = '';
  isLoading = false;
  sortField: string = 'date';
  sortDirection: 'asc' | 'desc' = 'desc';
  searchTerm: string = '';

  constructor(
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem("isAdmin") !== "true") {
      this.router.navigate(['/suivi']);
      return;
    }
    // Récupérer le tri sauvegardé depuis localStorage_SP-GetLogs
    const savedSort = localStorage.getItem('localStorage_SP-GetLogs');
    if (savedSort) {
      try {
        const sortData = JSON.parse(savedSort);
        this.sortField = sortData.field || 'date';
        this.sortDirection = sortData.direction || 'desc';
      } catch (e) {
        console.error('Erreur lors de la récupération du tri logs :', e);
      }
    }
    this.getLogs(1);
    this.getCategories();
  }
  
  toggleSort(field: string): void {
    if (this.sortField === field) {
      // Si on clique sur la même colonne, inverser la direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Si on clique sur une nouvelle colonne, trier par ordre croissant
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    
    // Sauvegarder le tri dans localStorage_SP-GetLogs
    try {
      localStorage.setItem('localStorage_SP-GetLogs', JSON.stringify({
        field: this.sortField,
        direction: this.sortDirection
      }));
    } catch (e) {
      console.error('Erreur lors de la sauvegarde du tri logs :', e);
    }
    
    this.applySort();
  }
  
  applyFilter(): void {
    let filtered = [...this.logs];
    
    // Filtre par terme de recherche
    if (this.searchTerm && this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(log => {
        // Rechercher dans le texte
        const texteMatch = log.texte?.toLowerCase().includes(term) || false;
        
        // Rechercher dans la catégorie
        const categorieMatch = log.categorie?.toLowerCase().includes(term) || false;
        
        // Rechercher dans la date formatée
        let dateMatch = false;
        if (log.date) {
          try {
            const dateObj = new Date(log.date);
            const dateFormatted = dateObj.toLocaleDateString('fr-FR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            }).toLowerCase();
            dateMatch = dateFormatted.includes(term);
          } catch (e) {
            // Si la date n'est pas valide, essayer de la convertir en string
            dateMatch = String(log.date).toLowerCase().includes(term);
          }
        }
        
        return texteMatch || categorieMatch || dateMatch;
      });
    }
    
    // Appliquer le tri
    this.filteredLogs = filtered.sort((a, b) => {
      let valueA: any;
      let valueB: any;
      
      switch (this.sortField) {
        case 'date':
          valueA = new Date(a.date).getTime();
          valueB = new Date(b.date).getTime();
          return this.sortDirection === 'asc' 
            ? valueA - valueB 
            : valueB - valueA;
        
        case 'categorie':
          valueA = a.categorie?.toLowerCase() || '';
          valueB = b.categorie?.toLowerCase() || '';
          return this.sortDirection === 'asc' 
            ? valueA.localeCompare(valueB) 
            : valueB.localeCompare(valueA);
        
        default:
          return 0;
      }
    });
  }
  
  applySort(): void {
    this.applyFilter();
  }

  getLogs(page: number): void {
    if (page < 1) return;

    this.isLoading = true;

    const body = {
      categorie: this.categorie || '',
      page: page
    };

    this.globalService.post('/SP-GetLogs/', body).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response.status && response.data) {
          const logs = response.data.logs || [];
          const total = response.data.total || 0;
          const totalPages = Math.ceil(total / 100);

          this.logs = logs;
          this.total = total;
          this.totalPages = totalPages;
          this.currentPage = page;
          // Appliquer le filtre après le chargement des logs
          this.applyFilter();
        } else {
          console.warn("⚠️ Réponse invalide ou vide.");
          this.logs = [];
          this.filteredLogs = [];
          this.total = 0;
          this.totalPages = 1;
          this.currentPage = 1;
          this.applyFilter();
        }
      },
      (err) => {
        this.isLoading = false;
        console.error("❌ Erreur getLogs :", err);
        this.logs = [];
        this.filteredLogs = [];
        this.total = 0;
        this.totalPages = 1;
        this.currentPage = 1;
        this.applyFilter();
      }
    );
  }

  getCategories(): void {
    this.globalService.get('/SP-GetAllCategories/').subscribe(
      (response: any) => {
        if (response.status && response.data?.categories) {
          this.categories = response.data.categories;
        } else {
          this.categories = [];
        }
      },
      (err) => {
        console.error("❌ Erreur getCategories :", err);
        this.categories = [];
      }
    );
  }

  chooseCategorie(event: any): void {
    const value = event.target.value;
    this.categorie = value || '';
    this.getLogs(1);
    // Le filtrage par recherche sera appliqué dans applyFilter après le chargement
  }
}
